const translations = {
  "en": {
    "%{var0} Forecast": "%{var0} Forecast",
    "View Detail": "View Detail",
    "View Report": "View Report"
  },
  "zh-tw": {
    "%{var0} Forecast": "%{var0} 預測",
    "View Detail": "查看細節",
    "View Report": "查看報告"
  }
};

export default translations;
